/* eslint-disable import/prefer-default-export */
import { defaultTabName } from '@src/modules/changes/configurations/tab.configurations'
import type { ChangeInfo } from '@src/endpoints/services/changeMgr.service'
import {
  CommonTypeCount,
  ResourceTypeEnum
} from '@src/endpoints/services/commonHdr.service'
import { toUpper } from 'lodash'

export interface ChangeCount extends CommonTypeCount {}
export interface ChangeItem extends ChangeInfo {
  type?: string
  identity_account_name?: string
}

export type Tab = ResourceTypeEnum | 'ALL'

export interface TableOptions {
  pagesCount?: number
  pageNumber?: number
  pageSize?: number
  sortField?: string
  asc?: boolean
  searchValue?: string
  searchFields?: any[]
}

export const defaultTab: Tab = toUpper(defaultTabName) as Tab

export const defaultState = {
  useChangesPage: true,
  changesList: [] as ChangeItem[],
  isPending: false,
  counts: [] as ChangeCount[],
  highChanges: 0,
  totalChanges: 0,
  error: null as any,
  pagesCount: 0,
  selectedType: defaultTab as Tab,
  highCount: 0,
  mediumCount: 0,
  lowCount: 0,
  totalCount: 0
}

export type ChangesState = typeof defaultState
